import Geolocation from 'ol/Geolocation';
import { AppStorage } from "./AppStorage";
import * as olSphere from 'ol/sphere';
import TrailwiseEventBus from './TrailwiseEventBus';
import { Coordinate } from 'ol/coordinate';
import * as olProj from 'ol/proj';
import LineString from 'ol/geom/LineString';

export class GeoData {
    public data: Array<LocationData>;

    public constructor() {
        this.data = new Array<LocationData>();
    }

    public add = (data: Geolocation): void => {
       const location = new LocationData(data);
       let prevLoc: LocationData;

        if (this.data.length > 0) {
            //get the coords from the previous entry so we can calculate the distance
            prevLoc = this.data[this.data.length - 1];
            //let prevCord: Coordinate = olProj.fromLonLat([prevLoc.coords.longitude, prevLoc.coords.latitude], "EPSG:3857");
            //let currentCord: Coordinate = olProj.fromLonLat([location.coords.longitude, location.coords.latitude], "EPSG:3857");

            let prevCord: Coordinate = [prevLoc.coords.longitude, prevLoc.coords.latitude];
            let currentCord: Coordinate = [location.coords.longitude, location.coords.latitude];
            let ls = new LineString([prevCord, currentCord])
            //location.distanceFromPrevious = olSphere.getDistance(prevCord, currentCord);
            location.distanceFromPrevious = ls.getLength();
        }        
        this.data.push(location);
    }
}

export class LocationData {
    public coords: LocationCoords;
    public timestamp: number;
    public time: string;
    public distanceFromPrevious: number;

    public constructor(data: Geolocation) {
        this.timestamp = new Date().getTime();
        this.time = new Date().getMinutes().toString() + ":" + new Date().getSeconds().toString() + ":" + new Date().getMilliseconds().toString();
        
        this.coords = new LocationCoords();
        this.coords.speed = data.getSpeed() || 0;
        this.coords.accuracy = data.getAccuracy() || 0;
        this.coords.altitudeAccuracy = data.getAltitudeAccuracy() || 0;
        this.coords.altitude = data.getAltitude() || 0;
        this.coords.longitude = data.getPosition()[0];
        this.coords.latitude = data.getPosition()[1];
        this.coords.heading = data.getHeading() || 0;
    }
}

export class LocationCoords {
    public speed: number;
    public accuracy: number;
    public altitudeAccuracy: number;
    public altitude: number;
    public longitude: number;
    public heading: number;
    public latitude: number;
}

export class AppRecordGeoLocation {

    private appStorage: AppStorage;

    public constructor() {
        const self = this;
        this.appStorage = new AppStorage();

        TrailwiseEventBus.trackingStart.on(function () {
            self.onTrackingStarted();
        });
        TrailwiseEventBus.trackingEnd.on(function () {
            self.onTrackingEnded();
        });
        TrailwiseEventBus.trackingGeolocationChange.on(function (geoLocation:Geolocation) {
            self.onTrackingGeolocationChange(geoLocation);
        });        
    }

    private onTrackingStarted = (): void => {
        this.clearGeoData();
    }

    private onTrackingGeolocationChange = (geoLocation: Geolocation): void => {
        this.addGeoData(geoLocation);
    }

    private onTrackingEnded = (): void => {
      
    }

    private addGeoData = (data: Geolocation): void => {
        let obj = JSON.parse(this.appStorage.getValue("geodata")) as GeoData

        let d = new GeoData();
        d.data = obj.data;
        d.add(data);
        this.appStorage.setValue("geodata", JSON.stringify(d));
    }

    private clearGeoData = (): void => {
        this.appStorage.clear("geodata");
        this.appStorage.setValue("geodata", JSON.stringify(new GeoData()));
    }
}

